<table
  class="details-table"
  *ngIf="job">
  <tr
    *ngIf="transferCounts; else transferredToMe"
    class="transfers-row">
    <td class="detail-label">{{ ("transfers" | i18n) || "Transfers" }}</td>
    <td class="transfers-info-list">
      <app-job-list-item-transfers
        [transferCounts]="transferCounts"
        [job]="job"></app-job-list-item-transfers>
    </td>
  </tr>
  <ng-template #transferredToMe>
    <tr
      *ngIf="transferredToMeText"
      class="transfers-row"
      [attr.data-cy]="'job-transfer-info-transferred'">
      <td class="detail-label">{{ ("transfers" | i18n) || "Transfers" }}</td>
      <td>
        <div class="transfer-info">{{ transferredToMeText }}</div>
      </td>
    </tr>
  </ng-template>
  <tr *ngIf="job.department.costCenter">
    <td class="detail-label">{{ ("costCenter" | i18n) || "Kostenstelle" }}</td>
    <td>{{ job.department.costCenter }}</td>
  </tr>
  <tr
    *ngIf="
      ((job.organisation &&
        job.organisation.address &&
        (job.organisation.address.street ||
          job.organisation.address.zip ||
          job.organisation.address.location)) ||
        job.department.phone) &&
      (isAgency$ | async)
    ">
    <td class="detail-label">{{ ("details" | i18n) || "Details" }}</td>
    <td>
      {{
        job.organisation.address?.street
          ? job.organisation.address?.street + ", "
          : ""
      }}
      {{
        job.organisation.address?.zip ? job.organisation.address?.zip + " " : ""
      }}
      {{
        job.organisation.address?.location
          ? job.organisation.address?.location
          : ""
      }}
      {{
        !job.department.phone
          ? ""
          : job.organisation.address
          ? " | " + job.department.phone
          : job.department.phone
      }}
    </td>
  </tr>
  <tr *ngIf="job.caseNumber">
    <td class="detail-label">{{ "caseNumber" | i18n }}</td>
    <td data-cy="details-table-caseNumber">{{ job.caseNumber }}</td>
  </tr>
  <tr *ngIf="job.description">
    <td class="detail-label">{{ ("description" | i18n) || "Beschreibung" }}</td>
    <td data-cy="details-table-description">{{ job.description }}</td>
  </tr>
  <tr *ngIf="job?.jobType !== undefined">
    <td class="detail-label">{{ ("jobType" | i18n) || "Dienstart" }}</td>
    <td>
      {{ ("jobTypeEnum." + (job?.jobType || "") | i18n) || "" }}
    </td>
  </tr>
  <ng-container *ngIf="loggedInCustomer$ | async as loggedInCustomer">
    <tr
      *ngIf="job?.customerInternalInformation?.[loggedInCustomer?._id || '']?.demandReason">
      <td class="detail-label">
        {{ ("demandReason" | i18n) || "Dienstgrund" }}
      </td>
      <td>
        {{ job?.customerInternalInformation?.[loggedInCustomer?._id || '']?.demandReason?.displayName|| '' }}
      </td>
    </tr>
    <tr
      *ngIf="job?.customerInternalInformation?.[loggedInCustomer?._id || '']?.description">
      <td class="detail-label">
        {{ ("internalDescription" | i18n) || "Interne Beschreibung" }}
      </td>
      <td>
        {{ job?.customerInternalInformation?.[loggedInCustomer?._id || '']?.description || '' }}
      </td>
    </tr>
  </ng-container>
  <tr *ngIf="jobCertificates$ | async as certificatesString">
    <td class="detail-label">
      {{ ("certificates" | i18n) || "Qualifikation" | titlecase }}
    </td>
    <td>{{ certificatesString }}</td>
  </tr>
  <tr *ngIf="job?.yourself?.customer?.displayName && (isAgency$ | async)">
    <td class="detail-label">
      {{ ("offerFrom" | i18n) || "Angebot von" | titlecase }}
    </td>
    <td data-cy="customer-name-text">
      {{ job?.yourself?.customer?.displayName }}
    </td>
  </tr>
  <tr
    *ngFor="
      let row of (nonDefaultCustomCriteriaRows$ | async) || [];
      trackBy: trackByCustomCriteriaLabel
    ">
    <td class="detail-label">{{ row.label }}</td>
    <td>
      <ng-container *ngIf="row.toggleValue !== undefined">
        {{ (row.toggleValue ? "yes" : "no") | i18n }}
      </ng-container>
      <ng-container *ngIf="row.toggleValue === undefined">
        {{ row.selectText }}
      </ng-container>
    </td>
  </tr>
  <tr *ngIf="isOwnedOrganisationJob$ | async">
    <td class="detail-label">
      {{ ("bookedBy" | i18n) || "Gebucht von" }}
    </td>
    <td>{{ job.customer.displayName }}</td>
  </tr>
  <tr>
    <td class="detail-label">
      {{ ("created" | i18n) || "Erstellt" }}
    </td>
    <td *ngIf="job.createdAt">
      {{
        job.createdAt * 1000
          | convertToDateObject
          | displayDate: "dd.MM.yyyy HH:mm"
      }}
      / {{ job.createdBy.firstName }} {{ job.createdBy.lastName }},
      {{ job.customer.displayName }}
    </td>
  </tr>
  <tr
    *ngIf="job?.status === JobStatusEnum.CANCELED"
    data-cy="job-canceled-hint">
    <td class="detail-label">{{ "canceled" | i18n }}</td>
    <td>
      {{ (job?.canceledAt || 0) * 1000 | date: "short" }} /
      {{ job?.cancelReason?.displayName?.[(loggedInUser$ | async)?.locale || 'de'] || "" }}
    </td>
  </tr>
</table>
